import React, { useContext, useEffect, useRef, useState } from "react";
import PdfViewer from "../pdfViewer";
import PdfURLContext from "../../../../../../context/pdfURL/pdfURLContext";
import Additives from "../additives";
import TabLink from "../../../../promptManagement/views/_partials/tabLink";
import plusicon from "../../../../../../styles/images/mksapp/plus-icon-white.svg";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { getChatHistoryList } from "../../../services/chatHistory";
//import { fetchChatHistory } from "../../../services/chatHistory"; // Import the function to fetch chat history
import { UserContext } from "../../../../../../context/user/userContext";
import { checkIfPageNoExists } from "../../../../../../services/commonService";
import { StrictErrorBoundary } from "../../../../../../helper/shared/strictErrorBoundary";
import { isPDF } from "../../../../../../services/commonService";
const ChatHistory = (props) => {
  const {
    isSkillChat,
    isFileType,
    isMKSChat,
    setSelectedAdditives,
    openPdfViewer,
    setOpenPdfViewer,
    selectedCitation,
    setIsClearChat,
    isChatVisible,
    resetAdditives,
    setResetAdditives,
    isMKSProcessing,
    isSkillProcessing,
    isMessageTyping,
    skill,
    pdfClass,
    setPdfClass,
    conversationShortName,
    handleChatHistoryRowClick,
    onLinkClick,
    isAdditiveExpanded,
    setIsAdditiveExpanded,
    expandChecks,
    setExpandChecks,
  } = props;

  const { pageNo, setPageNo, url, setUrl, showTab, setShowTab } =
    useContext(PdfURLContext);
  //const [showTab, setShowTab] = useState(1);
  const [expandClass, setExpandClass] = useState(false);
  //const [expandChecks, setExpandChecks] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [collapsedSections, setCollapsedSections] = useState({
    today: true,
    yesterday: true,
    last7Days: true,
    last30Days: true,
    last90Days: true,
  });
  const chatRef = useRef(null);
  const toggleButtonRef = useRef(null);
  const newChatRef = useRef(null);
  const additiveRef = useRef(null);

  const { state } = useContext(UserContext);
  const userId = state?.user?.userProfile?.user_id;

  useEffect(() => {
    setShowTab(1);
    // setCollapsedSections((prev) => ({
    //   ...prev,
    //   today: true,
    // }));
  }, [skill]);

  useEffect(() => {
    const fetchChatHistory = async () => {
      try {
        const data = await getChatHistoryList(userId, skill?.Id);
        setChatHistory(data?.conversations ? data?.conversations : []);
      } catch (error) {
        console.error("Failed to fetch chat history:", error);
      }
    };
    if (userId && skill?.Id) {
      fetchChatHistory();
    }
  }, [userId, skill?.Id, expandClass]);

  useEffect(() => {
    //loadChatHistory();
  }, [skill, conversationShortName]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!newChatRef.current.contains(e.target)) {
        setExpandClass(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   const handleAdditiveClickOutside = (e) => {
  //     if (!additiveRef.current.contains(e.target)) {
  //       setExpandChecks(false);
  //       setIsAdditiveExpanded(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleAdditiveClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleAdditiveClickOutside);
  //   };
  // }, []);

  const toggleSectionCollapse = (section) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const collapseCheck = () => {
    setExpandChecks(!expandChecks);
    setIsAdditiveExpanded(!isAdditiveExpanded);
  };

  const collapsePdf = () => {
    onLinkClick(pdfClass);
    setPdfClass(!pdfClass);
    if (checkIfPageNoExists(selectedCitation.filepath)) {
      const match = selectedCitation.filepath.match(/#page=(\d+)/);
      setPageNo(parseInt(match[1], 10));
    } else {
      setPageNo(1);
    }
    setUrl(selectedCitation.url);
  };

  const collapseChat = () => {
    setExpandClass(!expandClass);
  };

  useEffect(() => {
    if (url === undefined || url === null) {
      setExpandClass(true);
      setPdfClass(true);
    } else {
      if (url !== "") {
        if (!isPDF(url)) {
          openFileInNewTab(url);
        }
        setPdfClass(false);
        setOpenPdfViewer(true);
      } else {
        setExpandClass(false);
        setPdfClass(false);
      }
    }
    if (!isSkillChat) {
      setExpandChecks(false);
      setIsAdditiveExpanded(false);
    }
  }, [url, isSkillChat, pageNo]);

  // Split additives array into two columns

  const openFileInNewTab = (docUrl) => {
    // const encodedUrl = encodeURIComponent(docUrl);
    // const viewerUrl = `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`;
    // window.open(viewerUrl, "_blank", "noopener,noreferrer");
    //window.open(docUrl + "&response-content-disposition=inline", "_blank");
    window.open(docUrl, "_blank");
  };

  return (
    <>
      <div className="chat-right">
        <div
          className={
            isMKSProcessing || isSkillProcessing || isMessageTyping
              ? "toggle-areas disabled-div"
              : "toggle-areas"
          }
        >
          {skill !== null && skill !== undefined && !isFileType && (
            <div
              className={
                expandClass
                  ? "expand-history-btn rotate"
                  : expandChecks
                  ? "expand-history-btn hide"
                  : "expand-history-btn"
              }
              ref={toggleButtonRef}
              onClick={collapseChat}
              title="Chat History"
            />
          )}
          {isFileType && isSkillChat && !isMKSChat && (
            <div
              className={
                expandClass
                  ? "expand-checklist-btn hide"
                  : "expand-checklist-btn"
              }
              ref={toggleButtonRef}
              onClick={collapseCheck}
              title="Additives"
            />
          )}

          <div
            className={
              expandClass
                ? "chat-history hide"
                : "chat-history " && expandChecks
                ? "chat-history pdfhide"
                : "chat-history "
            }
            ref={toggleButtonRef}
          >
            {url && openPdfViewer && (
              <div
                className={
                  pdfClass ? "pdf-full-expand hide" : "pdf-full-expand "
                }
              >
                <div
                  className=" pdf-expand"
                  onClick={() => {
                    collapsePdf();
                  }}
                ></div>
                <div
                  className={
                    pdfClass ? "prompt-tabs w-tabs hide" : "prompt-tabs w-tabs "
                  }
                >
                  <div
                    className="tabs-menu h-flex head-wrapper w-tab-menu chattab-wrap"
                    role="tablist"
                  >
                    <TabLink
                      tabId="1"
                      href="#"
                      isSelected={showTab === 1}
                      onClick={() => setShowTab(1)}
                    >
                      Supporting Content
                    </TabLink>
                    {skill.ShowCitation && (
                      <TabLink
                        tabId="2"
                        href="#"
                        isSelected={showTab === 2}
                        //onClick={() => setShowTab(2)}
                        onClick={() =>
                          isPDF(url) ? setShowTab(2) : openFileInNewTab(url)
                        }
                      >
                        Citation
                      </TabLink>
                    )}
                  </div>
                  <div className="w-tab-content">
                    {showTab === 1 && (
                      <>
                        <div className="inner-tab-content">
                          <div className="text-wrap">
                            <h3>{selectedCitation.filepath}</h3>
                            <p>
                              <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                components={{
                                  ol: ({ children }) => (
                                    <ol
                                      style={{
                                        paddingLeft: "1.5rem",
                                        margin: "0",
                                      }}
                                    >
                                      {children}
                                    </ol>
                                  ),
                                  li: ({ children }) => (
                                    <li
                                      style={{
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {children}
                                    </li>
                                  ),
                                }}
                                rehypePlugins={[rehypeRaw]}
                              >
                                {selectedCitation.content}
                              </ReactMarkdown>
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                    {showTab === 2 && (
                      <>
                        <div className="pdfview overlap">
                          <StrictErrorBoundary
                            key={url}
                            fallback={
                              <div className="fallback-display">
                                PDF unavailable
                              </div>
                            }
                          >
                            <div
                              // key={`pdf-wrapper-${key}`}
                              className="control-section"
                            >
                              <PdfViewer pdfUrl={url} pageNo={pageNo} />
                            </div>
                          </StrictErrorBoundary>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          ref={chatRef}
          className={expandClass ? "full-height" : "full-height-auto"}
        >
          <div
            ref={newChatRef}
            className={
              expandClass ? "chat-history-sec show" : "chat-history-sec"
            }
          >
            <div className="flex-row aligned-margin">
              <h4 className="h4">Chat History</h4>{" "}
              {/* <div className="bookmark-icon"></div> */}
            </div>
            <div
              className={
                isChatVisible
                  ? "button new-chatbutton "
                  : "button-newchat-disabled"
              }
              disabled={!isChatVisible}
              onClick={() => {
                setIsClearChat(true);
                setOpenPdfViewer(false);
              }}
            >
              <img src={plusicon} alt="plusicon" className="plusimg" /> New Chat
            </div>
            <div className="recent-history">
              {/* Today Column */}
              <div className="collapse-div">
                <div
                  className="flex-start font-bold"
                  onClick={() => toggleSectionCollapse("today")}
                >
                  <div
                    class={
                      collapsedSections.today
                        ? "down-arrow rotate"
                        : "down-arrow "
                    }
                  ></div>{" "}
                  Today
                </div>
                <div
                  className={
                    collapsedSections.today
                      ? "history-box show"
                      : "history-box "
                  }
                >
                  {(() => {
                    const today = new Date();
                    const oneDayItems = chatHistory
                      ?.filter((item) => {
                        const conversationDate = new Date(
                          item.conversationDateTime
                        );
                        return (
                          conversationDate.getDate() === today.getDate() &&
                          conversationDate.getMonth() === today.getMonth() &&
                          conversationDate.getFullYear() === today.getFullYear()
                        );
                      })
                      .sort(
                        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                      ); // Sort by newest first

                    return oneDayItems.length > 0 ? (
                      oneDayItems.map((item, index) => (
                        <p
                          key={index}
                          className="recent-history-title"
                          onClick={() => handleChatHistoryRowClick(item)}
                        >
                          {item.conversationShortName ||
                            "Untitled Conversation"}
                        </p>
                      ))
                    ) : (
                      <p className="recent-history-title-norecords">
                        No recent history
                      </p>
                    );
                  })()}
                </div>
              </div>

              {/* Yesterday Column */}
              <div className="collapse-div">
                <div
                  className="flex-start font-bold"
                  onClick={() => toggleSectionCollapse("yesterday")}
                >
                  <div
                    class={
                      collapsedSections.yesterday
                        ? "down-arrow rotate"
                        : "down-arrow "
                    }
                  ></div>
                  Yesterday
                </div>
                <div
                  className={
                    collapsedSections.yesterday
                      ? "history-box show"
                      : "history-box "
                  }
                >
                  {(() => {
                    const today = new Date();
                    const yesterday = new Date(today);
                    yesterday.setDate(today.getDate() - 1);

                    const yesterdayItems = chatHistory
                      ?.filter((item) => {
                        const conversationDate = new Date(
                          item.conversationDateTime
                        );
                        return (
                          conversationDate.getDate() === yesterday.getDate() &&
                          conversationDate.getMonth() ===
                            yesterday.getMonth() &&
                          conversationDate.getFullYear() ===
                            yesterday.getFullYear()
                        );
                      })
                      .sort(
                        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                      ); // Sort by newest first

                    return yesterdayItems.length > 0 ? (
                      yesterdayItems.map((item, index) => (
                        <p
                          key={index}
                          className="recent-history-title"
                          onClick={() => handleChatHistoryRowClick(item)}
                        >
                          {item.conversationShortName ||
                            "Untitled Conversation"}
                        </p>
                      ))
                    ) : (
                      <p className="recent-history-title-norecords">
                        No recent history
                      </p>
                    );
                  })()}
                </div>
              </div>

              {/* Previous 7 Days Column */}
              <div className="collapse-div">
                <div
                  className="flex-start font-bold"
                  onClick={() => toggleSectionCollapse("last7Days")}
                >
                  <div
                    class={
                      collapsedSections.last7Days
                        ? "down-arrow rotate"
                        : "down-arrow "
                    }
                  ></div>
                  Last 7 Days
                </div>
                <div
                  className={
                    collapsedSections.last7Days
                      ? "history-box show"
                      : "history-box "
                  }
                >
                  {(() => {
                    const today = new Date();
                    const startDate = new Date();
                    startDate.setDate(today.getDate() - 7);

                    const yesterday = new Date();
                    yesterday.setDate(today.getDate() - 1);

                    const sevenDaysItems = chatHistory
                      ?.filter((item) => {
                        const conversationDate = new Date(
                          item.conversationDateTime
                        );
                        return (
                          conversationDate >= startDate &&
                          conversationDate < yesterday.setHours(0, 0, 0, 0)
                        );
                      })
                      .sort(
                        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                      ); // Sort by newest first

                    return sevenDaysItems.length > 0 ? (
                      sevenDaysItems.map((item, index) => (
                        <p
                          key={index}
                          className="recent-history-title"
                          onClick={() => handleChatHistoryRowClick(item)}
                        >
                          {item.conversationShortName ||
                            "Untitled Conversation"}
                        </p>
                      ))
                    ) : (
                      <p className="recent-history-title-norecords">
                        No recent history
                      </p>
                    );
                  })()}
                </div>
              </div>

              {/* Previous 30 Days Column */}
              <div className="collapse-div">
                <div
                  className="flex-start font-bold"
                  onClick={() => toggleSectionCollapse("last30Days")}
                >
                  <div
                    class={
                      collapsedSections.last30Days
                        ? "down-arrow rotate"
                        : "down-arrow "
                    }
                  ></div>
                  Last 30 Days
                </div>
                <div
                  className={
                    collapsedSections.last30Days
                      ? "history-box show"
                      : "history-box "
                  }
                >
                  {(() => {
                    const thirtyDaysItems = chatHistory
                      ?.filter((item) => {
                        const conversationDate = new Date(
                          item.conversationDateTime
                        );
                        const thirtyDaysAgo = new Date();
                        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                        const sevenDaysAgo = new Date();
                        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
                        return (
                          conversationDate >= thirtyDaysAgo &&
                          conversationDate < sevenDaysAgo
                        );
                      })
                      .sort(
                        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                      ); // Sort by newest first

                    return thirtyDaysItems.length > 0 ? (
                      thirtyDaysItems.map((item, index) => (
                        <p
                          key={index}
                          className="recent-history-title"
                          onClick={() => handleChatHistoryRowClick(item)}
                        >
                          {item.conversationShortName ||
                            "Untitled Conversation"}
                        </p>
                      ))
                    ) : (
                      <p className="recent-history-title-norecords">
                        No history in this period
                      </p>
                    );
                  })()}
                </div>
              </div>

              {/* Previous Year Column */}
              <div className="collapse-div">
                <div
                  className="flex-start font-bold"
                  onClick={() => toggleSectionCollapse("last90Days")}
                >
                  <div
                    class={
                      collapsedSections.last90Days
                        ? "down-arrow rotate"
                        : "down-arrow "
                    }
                  ></div>
                  Last 90 Days
                </div>
                <div
                  className={
                    collapsedSections.last90Days
                      ? "history-box show"
                      : "history-box"
                  }
                >
                  {(() => {
                    const ninetyDaysItems = chatHistory
                      ?.filter((item) => {
                        const conversationDate = new Date(
                          item.conversationDateTime
                        );
                        const ninetyDaysAgo = new Date();
                        ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
                        const thirtyDaysAgo = new Date();
                        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                        return (
                          conversationDate <= thirtyDaysAgo && // older than 30 days
                          conversationDate >= ninetyDaysAgo
                        );
                      })
                      .sort(
                        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                      ); // Sort by newest first

                    return ninetyDaysItems.length > 0 ? (
                      ninetyDaysItems.map((item, index) => (
                        <p
                          key={index}
                          className="recent-history-title"
                          onClick={() => handleChatHistoryRowClick(item)}
                        >
                          {item.conversationShortName ||
                            "Untitled Conversation"}
                        </p>
                      ))
                    ) : (
                      <p className="recent-history-title-norecords">
                        No history in this period
                      </p>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          ref={additiveRef}
          className={expandClass ? "full-height-auto" : "full-height"}
        >
          {isFileType && isSkillChat && !isMKSChat && (
            <Additives
              setSelectedAdditives={setSelectedAdditives}
              expandChecks={expandChecks}
              resetAdditives={resetAdditives}
              setResetAdditives={setResetAdditives}
              isSkillProcessing={isSkillProcessing}
            ></Additives>
          )}
        </div>
      </div>
    </>
  );
};

export default ChatHistory;
